module.exports = __webpack_public_path__ + "img/x1-four.836e8730.png";